import React from "react"
import {BrowserRouter as Router, Route, Switch, Redirect} from "react-router-dom"
import Home from "./pages/Home/Home.jsx";
import HomeMp from "./pages/HomeMp/HomeMp.jsx";
import GuideMp from "./pages/GuideMp/GuideMp";
import Information from "./pages/Information/Information";
import About from "./pages/About/About";
import Contact from "./pages/Contact/Contact";
import Cooperation from "./pages/Cooperation/Cooperation";
import News from "./pages/News/News";
import NewsMp from "./pages/NewsMp/NewsMp";
import NewsDetails from "./pages/NewsDetails/NewsDetails";
import NewsDetailsMp from "./pages/NewsDetailsMp/NewsDetailsMp";
import MediaQuery from 'react-responsive';


function App() {
    return (
        <div className="App">
            <Router>
                {/*<Switch>*/}
                {/*    <Route path="/home" exact={true} component={Home}/>*/}
                {/*    <Route path="/information" exact={true} component={Information}/>*/}
                {/*    <Route path="/about" exact={true} component={About}/>*/}
                {/*    <Route path="/contact" exact={true} component={Contact}/>*/}
                {/*    <Route path="/cooperation" exact={true} component={Cooperation}/>*/}
                {/*    <Route path="/news" exact={true} component={News}/>*/}
                {/*    <Route path="/newsDetails/:id" exact={true}*/}
                {/*           component={(props) => <NewsDetails {...props} key={props.match.params.id}*/}
                {/*                                              isAuthed={true}/>}/>*/}
                {/*    <Redirect to="/home"/>*/}
                {/*</Switch>*/}
                <div>
                    <MediaQuery query='(min-device-width: 1224px)'>
                        <Route path="/home" exact={true} component={Home}/>
                        <Route path="/guide" exact={true} component={GuideMp}/>
                        <Route path="/information" exact={true} component={Information}/>
                        <Route path="/about" exact={true} component={About}/>
                        <Route path="/contact" exact={true} component={Contact}/>
                        <Route path="/cooperation" exact={true} component={Cooperation}/>
                        <Route path="/news" exact={true} component={News}/>
                        <Route path="/newsDetails/:id" exact={true}
                               component={(props) => <NewsDetails {...props} key={props.match.params.id}
                                                                  isAuthed={true}/>}/>
                        <Redirect to="/home"/>
                    </MediaQuery>
                    <MediaQuery query='(max-device-width: 1224px)'>
                        <Route path="/home" exact={true} component={HomeMp}/>
                        <Route path="/guide" exact={true} component={GuideMp}/>
                        <Route path="/news" exact={true} component={NewsMp}/>
                        <Route path="/newsDetails/:id" exact={true}
                               component={(props) => <NewsDetailsMp {...props} key={props.match.params.id}
                                                                  isAuthed={true}/>}/>
                        <Redirect to="/home"/>
                    </MediaQuery>
                </div>
            </Router>
        </div>
    );
}

export default App;
